import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCircleArrowDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCircleArrowDown"><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8 17V15.5H16V17H8ZM12 14.5607L8.68934 11.25L9.75 10.1893L11.25 11.6893V7H12.75V11.6893L14.25 10.1893L15.3107 11.25L12 14.5607Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCircleArrowDown;
